import { isScrolledToBottom } from "@prismicio/editor-support/DOM"
import { useStableCallback } from "@prismicio/editor-support/React"
import { useEffect } from "react"

export function useScrolledToPageBottom(onBottomReached: () => void) {
  const onBottomReachedStable = useStableCallback(onBottomReached)

  useEffect(() => {
    function handleScroll() {
      const hasReachedBottom = isScrolledToBottom(document.documentElement)
      if (hasReachedBottom) onBottomReachedStable()
    }

    window.addEventListener("wheel", handleScroll)
    window.addEventListener("scroll", handleScroll)

    return () => {
      window.removeEventListener("wheel", handleScroll)
      window.removeEventListener("scroll", handleScroll)
    }
  }, [onBottomReachedStable])
}
